import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _get from 'lodash/get'
import { H4 } from '../../Heading/index'
import Button, { TYPES } from '../../Button/index'
import { GiftLoading } from '../GiftLoading/index'
import {
  selectGiftRedeemProcessing,
  selectGiftRedeemErrorState,
  selectGiftRedeemSuccess,
  selectGiftIsExpired,
} from '../../../services/gift/selectors'
import { giftRedeem } from '../../../services/gift/actions'
import { selectPrimaryLanguage } from '../../../services/user/selectors'
import { useTranslation } from '../../../services/static-text/hooks'
import { get as getConfig } from '../../../config/index'
import { URL_GIFT_TERMS_AND_CONDITIONS } from '../../../services/url/constants'
import { getGiftTermsAndConditionsUrl } from '../../../services/url/index'
import Link, { TARGET_BLANK } from '../../Link/index'
import { GIFT_REDEEM_PAGE_STATIC_KEY as staticTextStoreKey } from './gift-redeem-page-static-key'

const config = getConfig()
const giftMultipleCurrenciesActive = !!_get(config, ['features', 'gift', 'multipleCurrencies'])

export function GiftSectionRedeem ({
  onCreateAccount,
  isLoggedIn,
  formatDate,
  translate,
  onLogin,
  gift,
}) {
  const dispatch = useDispatch()
  const token = gift.get('token')
  const expiresAt = gift.get('expiresAt')
  const processing = !!gift.get('processing')
  const hasBeenRedeemed = !!gift.get('redeemedAt')
  const isExpired = useSelector(selectGiftIsExpired)
  const redeemProcessing = useSelector(selectGiftRedeemProcessing)
  const redeemErrorState = useSelector(selectGiftRedeemErrorState)
  const redeemSuccess = useSelector(selectGiftRedeemSuccess)
  const translateByKey = useTranslation(staticTextStoreKey)
  const userLanguage = useSelector(selectPrimaryLanguage)
  if (!token
    || isExpired
    || processing
    || hasBeenRedeemed) {
    return null
  }

  const translationKey = isLoggedIn
    ? 'greetingBodyRedeem'
    : 'greetingBodyRedeemANON'

  return (
    <div className="gift-redeem__redemption">
      <H4>
        {translate('greetingTitleRedeem')}
        <aside>
          {translate('greetingSubtitleRedeem', { expiresAt: formatDate(expiresAt) })}
        </aside>
      </H4>
      <p>{translate(translationKey)}</p>
      <GiftLoading visible={redeemProcessing} />
      <p className="gift-redeem__agree-to-terms">
        {translateByKey('agreeToTermsAndConditions')}
        <Link
          to={
            giftMultipleCurrenciesActive
              ? getGiftTermsAndConditionsUrl(userLanguage)
              : URL_GIFT_TERMS_AND_CONDITIONS
            }
          target={TARGET_BLANK}
          >{translateByKey('termsAndConditionsLink')}
        </Link>
      </p>
      {isLoggedIn ? (
        <Button
          disabled={redeemProcessing || !!redeemErrorState || redeemSuccess}
          onClick={() => dispatch(giftRedeem())}
          type={TYPES.PRIMARY}
        >
          {redeemProcessing ? translate('processing') : translate('redeemCTA')}
        </Button>
      ) : (
        <React.Fragment>
          <Button
            // eslint-disable-next-line no-alert
            onClick={onCreateAccount}
            type={TYPES.PRIMARY}
          >
            {translate('createAccountCTA')}
          </Button>
          <Button
            onClick={onLogin}
            type={TYPES.SECONDARY}
          >
            {translate('loginCTA')}
          </Button>
        </React.Fragment>
      )}
      <p className="gift-redeem__terms-and-conditions">
        {translateByKey('termsAndConditionsStart')}
        <Link
          to={URL_GIFT_TERMS_AND_CONDITIONS}
          target={TARGET_BLANK}
        >{translateByKey('termsAndConditionsLink')}
        </Link>
        {translateByKey('termsAndConditionsEnd')}
      </p>
    </div>
  )
}

export default GiftSectionRedeem
